<template>
  <div>

    <pageTable ref="snTable"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/my_company/companySn"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="add_time">
          <DatePicker v-model="searchData.add_time" type="datetimerange" @on-change="timeChange"  placeholder="消费时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>
    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'

  export default {
    name: "companySn",
    components:{pageTable},
    props:{
      companyId:{
        type:Number,
        default: 0
      }
    },
    data() {
      return {
        searchData: {
          company_id:this.companyId,
          add_time:'',
          mobile:'',
          car_number:''
        },
        tableColumn: [
          {title: 'ID',key: 'id',align: "center"},
          {title: '发生数量',key: 'amount',align: "center"},
          {title: '消费前数量',key: 'before_amount',align: "center"},
          {title: '消费后数量',key: 'after_amount',align: "center"},
          {title: '类型',key: 'type_name',align: "center"},
          {title: '时间',key: 'add_time',align: "center",width:180},
          {title: '车牌号',key: 'car_number',align: "center"},
          {title: '手机号',key: 'user_mobile',align: "center"},
          {title: '备注',key: 'remark',align: "center"},
        ],
        tableData: [],

      }
    },
    methods: {
      exportData(){
        this.$commonFun.postProxy('admin/my_company/exportCompanySn',this.searchData).then((res)=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`余额记录.xlsx`)
          })
        })
      },
      timeChange(time) {
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchData.add_time = time
        }
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
